import React, { createContext } from "react";

export const UserContext = createContext(null);
export const RoleContext = createContext(null);